import { mapGetters, mapActions } from "vuex";
import CloseJobModal from "../../views/jobs/modals/CloseJobModal.vue";
import { required, maxLength } from "vuelidate/lib/validators";
import CloneModal from "../../views/InterviewProcess/cloneModal.vue";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";
import DeleteJobModal from "../../views/jobs/modals/DeleteJobModal.vue";
import {
  updateDraft,
  createJob,
  generatePositionIds,
  deleteJobDesc,
  checkInterviews,
} from "@/utils/apiFunctions.js";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import FolderModal from "../../components/teamsmodal/FolderModal.vue";
import { getJobList } from "../../utils/apiClient/jobs";

const jobDashboardMixins = {
  name: "jobDashboardMixins",
  components: {
    Spinner,
    FolderModal,
    CloneModal,
    DeleteJobModal,
    CloseJobModal,
    ConfirmModal,
  },
  props: {
    gridView: Boolean,
    jobList: Array,
    selectedJD: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      confirmModal: false,
      jobData: {
        title: "Delete Job",
        message1: "Are you sure you want to delete",
        message2: " job ? This action cannot be undone.",
        data: "",
      },

      // NUMBERS
      venPage: 0,
      buttonMsg: "",
      headerMsg: "",
      closedModal: false,
      buttonLoader: false,
      sharedModal: false,
      linkCopied: false,
      sharedLink: "",
      reset: false,
      venPageEnd: null,
      totalVen: null,
      page: 0,
      count: 40,
      delDetails: {},
      total: 0,
      pageEnd: null,
      vendorLength: null,

      // BOOLEAN
      openFilter: false,
      sortCard: false,
      typeCard: false,
      duplicateCloneName: false,
      showAdvanced: false,
      showCircleLoader: true,
      showSpinner: false,
      showLoader: false,
      ven: false,
      scoremodal: false,
      LoaderStatus: false,
      showdetails: false,
      showsortcard: false,
      showfiltercard: false,
      showTooltip: false,
      rec: false,
      showjdtypecard: false,
      showFolderModal: false,
      showDeleteModal: false,
      cloneModal: false,
      fromClose: false,
      fromOnHold: false,
      showCloseModal: false,
      // STRINGS
      actionType: null,
      viewMoreJDIndex: null,
      searchven: "",
      searchselven: "",
      clonejobId: "",
      cloneTitle: "",
      clonedata: "",
      preview: "",
      filtertest: "",
      jobID: "",
      shareLink: "",
      toggleIconValue: "",
      statusType: "1",
      status: "",
      jdtypeselected: "Active",
      sortColumn: "updatedAt",
      sortOrder: "-1",
      sortSelected: "6",
      customerID: this.$route.params.customerID,
      customerName: null,

      // ARRAYS
      positionInfo: [],
      advancedFields: [],
      normalFields: [],
      vendorDetails: [],
      vendor: [],
      values: [],
      delJob: [],
      closejob: [],
      reopenjob: [],
      sortOptions: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)(Default)", value: "6" },
      ],
      jdtypeoptions: [
        { text: "All", value: "All" },
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" },
        { text: "Closed", value: "Closed" },
        { text: "On Hold", value: "On Hold" },
        { text: "Not Sent For Approval", value: "Not Sent For Approval" },
        { text: "Pending For Approval", value: "Pending For Approval" },
        { text: "Accepted", value: "Accepted" },
        { text: "Rejected", value: "Rejected" },
      ],
      positionIDDesc: [
        { name: "Active", status: 1 },
        { name: "Cancelled", status: 0 },
        { name: "Lost", status: 4 },
        { name: "Closed", status: 3 },
        { name: "On Hold", status: 2 },
      ],

      // OBJECTS
      customFields: null,
      cloneData: {
        title: "Clone Job",
        labelname: "New Job Name",
      },
      newData: {},
      singleCustomer: {},
      cloneResponse: {},
      JobDescription: {},
      editableJD: {},
      folderUpRec: {},
      recruiter: {
        recruitersoption: [],
        recruiter_Id: "",
        email: "",
        username: "",
        role: "",
        userID: "",
      },
      convertJSONtoString: function (user) {
        return JSON.stringify({
          username: user.username,
          email: user.email,
          roleName: user.roleName,
          roles: user.roles,
          isActive: user.isActive,
          userID: user.userID,
          landingPage: user.landingPage,
          folderID: user.folderID,
        });
      },
    };
  },
  validations: {
    clonedata: {
      required,
      maxLength: maxLength(128),
    },
  },
  mixins: [toast],
  filters: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      getThirdPartyData: "getThirdPartyData",
    }),
    computedImageSrc() {
      const closeJobDelete = require("../../assets/img/newworkbench/internalhiring/closeJob-delete.svg");
      const moveJobHold = require("../../assets/img/newworkbench/internalhiring/moveJob-hold.svg");
      const moveJobActive = require("../../assets/img/newworkbench/internalhiring/moveJob-Active.svg");

      if (this.closedModal) {
        return closeJobDelete;
      }
      return !this.closejob.onHold ? moveJobHold : moveJobActive;
    },
    checkPermissionClone() {
      if (!this.roles.includes("CLONE_JOB")) return false;

      const { lead, manager } = this.getCustomerDetail;
      return (
        (lead && manager == null) || (!lead && manager) || (lead && manager)
      );
    },
    checkPermissionDelete() {
      if (!this.roles.includes("DELETE_JOB")) return false;

      const { lead, manager } = this.getCustomerDetail;
      return (
        (lead && manager == null) || (!lead && manager) || (lead && manager)
      );
    },

    jobStatus() {
      const itype = this.$route.query.itype;
      switch (itype) {
        case "Inactive":
          return "Inactive";
        case "Not Sent For Approval":
          return "Not Sent For Approval";
        case "Accepted":
          return "Accepted";
        case "Rejected":
          return "Rejected";
        case "Pending For Approval":
          return "Pending For Approval";
        case "Closed":
          return "Closed";
        case "On Hold":
          return "On Hold";
        default:
          return "";
      }
    },
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    headerContent() {
      if (this.closedModal) {
        return `Are you sure you want to close <span class="modalnamebluetext">"${this.closejob.title}"</span> job?`;
      }

      return this.closejob.onHold
        ? `Are you sure you want to move this job <span class="modalnamebluetext">"${this.closejob.title}"</span> Active from On-Hold?`
        : `Are you sure you want to move this job <span class="modalnamebluetext">"${this.closejob.title}"</span> to On-Hold?`;
    },

    isJdClosed() {
      return this.jdtypeselectedtext === "Closed";
    },
    ...mapGetters("jobDescriptionVUEX", {
      getCustomerDetail: "getCustomerDetail",
    }),
    experience() {
      if (this.singleCustomer.experienceRequired === "others") {
        return "12+ years";
      } else if (this.singleCustomer.experienceRequired === "0-2") {
        return "Fresher(0-2 years)";
      } else if (this.singleCustomer.experienceRequired === "2-4") {
        return "Junior(2-4 years)";
      } else if (this.singleCustomer.experienceRequired === "4-6") {
        return "Senior(4-6 years)";
      } else if (this.singleCustomer.experienceRequired === "6-8") {
        return "Lead(6-8 years)";
      } else {
        return "Management(8-12 years)";
      }
    },
    selvendor() {
      return this.vendor.filter((vend) => {
        return (
          !this.searchselven ||
          vend.name.toLowerCase().includes(this.searchselven.toLowerCase())
        );
      });
    },
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      singleJdDetails: "getSingleJdDetails",
    }),
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("folderVUEX", {
      selectedUsersList: "getSelectedUsers",
      selectedFoldersList: "getSelectedFolderIDs",
    }),
    sortName() {
      if (this.sortSelected == "1") {
        return "Name(Asce)";
      } else if (this.sortSelected == "2") {
        return "Name(Desc)";
      } else if (this.sortSelected == "3") {
        return "Date Created(Asce)";
      } else if (this.sortSelected == "4") {
        return "Date Created(Desc)";
      } else if (this.sortSelected == "5") {
        return "Date Modified(Asce)";
      }
      return "Date Modified(Desc)";
    },
    jdtypeselectedtext() {
      if (this.jdtypeselected == "Active") {
        return "Active";
      } else if (this.jdtypeselected == "Inactive") {
        return "Inactive";
      } else if (this.jdtypeselected == "Closed") {
        return "Closed";
      } else if (this.jdtypeselected == "On Hold") {
        return "On Hold";
      } else if (this.jdtypeselected == "Not Sent For Approval") {
        return "Not Sent For Approval";
      } else if (this.jdtypeselected == "Pending For Approval") {
        return "Pending For Approval";
      } else if (this.jdtypeselected == "Accepted") {
        return "Accepted";
      } else if (this.jdtypeselected == "Rejected") {
        return "Rejected";
      } else if (this.jdtypeselected == "All") {
        return "All";
      }
      return "Active";
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClick);
  },
  methods: {
    closeMainDeleteModal() {
      this.showCloseModal = false;
      this.fromOnHold = false;
      this.showDeleteModal = false;
      this.actionType = null;
    },
    moveToOnHold(option) {
      this.selectedOption = option;
      this.showDeleteModal = false;
      this.closejd();
    },
    onCloseJobModal() {
      this.fromOnHold = false;
      this.showCloseModal = false;
      this.showDeleteModal = true;
    },
    handleClick(event) {
      if (this.viewMoreJDIndex === null || this.viewMoreJDIndex === undefined)
        return;

      const dropdown = this.$refs.dropdown;
      const button = this.$refs["dropdown-button"];

      const dropdownEl = Array.isArray(dropdown) ? dropdown[0] : dropdown;
      const buttonEl = Array.isArray(button) ? button[0] : button;
      console.log(dropdownEl, "dropdown");
      console.log(buttonEl, "buttonEl");

      if (
        dropdownEl &&
        buttonEl &&
        !dropdownEl.contains(event.target) &&
        !buttonEl.contains(event.target)
      ) {
        this.viewMoreJDIndex = null;
      }
    },
    selectJD(job) {
      this.$emit("getJobDetails", job);
    },
    deselectJob(job) {
      this.$emit("deselectJob", job);
    },

    closeViewMore() {
      this.viewMoreJDIndex = null;
    },
    openViewMore(index) {
      this.viewMoreJDIndex = index;
    },

    ...mapActions({
      getJobDesc: "jobDescriptionVUEX/getJobDesc",
    }),
    // send for approval
    goToJobDetails(job) {
      if (job.status === "3" && !job.closed) {
        this.$router.push({
          path: this.roles.includes("GET_JOBDASHBOARD")
            ? "/jdflow/kanban"
            : this.roles.includes("GET_JOB_STATISTICS")
            ? "/jdflow/analytics"
            : "",
          query: {
            jobID: job.jobID,
            customerID: job.customerID,
            cardName: this.$route.params.cardName || this.$route.query.cardName,
            itype: this.jdtypeselected,
            isort: this.sortSelected,
            jobName: job.title,
            gridView: this.gridView,
          },
        });
      }
    },

    // POPULATE DATA FOR SELECTED FOLDERS AND USERS IN FOLDER STRUCTURE MODAL
    // reAssignJD(job) {
    //   this.editableJD = job;
    //   this.$store.commit("folderVUEX/resetExpand");
    //   this.$store.commit("folderVUEX/setModalType", "Recruiter");
    //   this.$store.commit("folderVUEX/setActiveFolder", {});
    //   let userList = [];
    //   let folderList = [];
    //   if (this.editableJD.assignedTo.length > 0) {
    //     this.editableJD.assignedTo.forEach((user) =>
    //       userList.push(this.convertJSONtoString(user))
    //     );
    //   }
    //   if (this.editableJD.userFolderIDs.Recruiters.length > 0) {
    //     this.editableJD.userFolderIDs.Recruiters.forEach((folderIDs) =>
    //       folderList.push(folderIDs)
    //     );
    //   }
    //   this.$store.commit("folderVUEX/saveSelectedUsers", userList);
    //   this.$store.commit("folderVUEX/saveSelectedFolders", folderList);
    //   this.showFolderModal = true;
    //   this.$store.commit("jobDescriptionVUEX/saveSingleJdDetails", job);
    // },

    // CLOSE RE-ASSIGN RECRUITER MODAL

    // SAVE SELECTED RECRUITERS AND CLOSE MODAL

    // reassign recruiters

    funcForOutsideClickForScoreCard() {
      this.scoremodal = false;
    },

    openReassign(job) {
      this.$router.push({
        name: "CreateJob",
        query: {
          jobID: job.jobID,
          type: "Edit",
          to: "allocate",
          customerName: this.$route.query.cardName,
          itype: this.jdtypeselected,
          isort: this.sortSelected,
          gridView: this.gridView,
        },
        params: {
          customerName: this.$route.query.cardName,
        },
      });
    },
    async addCloneJob(newJdTitle) {
      // Reset the form validation.

      this.$v.$reset();
      // Remove unnecessary fields from the cloned job response.
      delete this.cloneResponse.jobID;
      delete this.cloneResponse.createdBy;
      delete this.cloneResponse.createdAt;
      delete this.cloneResponse.groupID;
      delete this.cloneResponse.activity;
      delete this.cloneResponse.approved;
      delete this.cloneResponse.updatedAt;
      delete this.cloneResponse.preApproved;

      // Set default values for status and remarks fields.
      this.cloneResponse.status = "1";
      this.cloneResponse.closed = false;
      this.cloneResponse.remarks = "";

      // Set the title field of the cloned job response to the input value.
      this.cloneResponse.title = newJdTitle;

      // For PositionIDs
      this.cloneResponse.recruiterConfig.positionIDs = [];
      this.cloneResponse.assignedTo.forEach((recruiter) => {
        recruiter.positionIDs = [];
      });

      await this.generatePositionIds();

      const res = await createJob(this.cloneResponse);

      if (res.status == 200) {
        let toastText = `"${this.cloneTitle}"  has been cloned as "${this.cloneResponse.title} "`;
        this.dynamicToast("cloned-job", "Successfully cloned", toastText);
        this.buttonLoader = false;
        this.closeCloneModal();
        this.cloneResponse.title = "";
        newJdTitle = "";

        // Call the API to  get all the jobs

        this.$emit("getJobs");
        // Reset the input field and toggle icon.
        this.toggleIconValue = "";
        this.clonedata = "";
      } else if (res.status == 208) {
        this.duplicateCloneName = true;
        this.LoaderStatus = false;
        this.buttonLoader = false;
      } else {
        this.buttonLoader = false;
        this.LoaderStatus = false;
        // Show a generic error message if the API call fails.
        this.errorModal("Something went wrong!");
      }
    },
    async closejd(deleteData) {
      try {
        let payload = {
          customerID: this.closejob.customerID,
          jobID: this.closejob.jobID,
        };
        if (this.closedModal || deleteData) {
          payload.closed = true;
        } else {
          payload.onHold = !this.closejob.onHold;
        }
        if (deleteData) {
          payload.positionStatus = parseInt(deleteData.positionStatus);
          payload.comments = deleteData.comments;
        }
        this.LoaderStatus = true;
        const method = this.closedModal || deleteData ? "delete" : "patch";
        const response = await deleteJobDesc(payload, method);

        if (response.status === 200) {
          this.$emit("resetPagination");

          this.deselectJob(null);
          let toastAction =
            this.closedModal || deleteData
              ? "closed"
              : this.closejob.onHold
              ? "moved to Active"
              : "moved to On-Hold";
          let toastText = `"${this.closejob.title}" has been ${toastAction}.`;
          let toastMsg =
            this.closedModal || deleteData
              ? "closed-job"
              : this.closejob.onHold
              ? "success"
              : "success";
          this.dynamicToast(toastMsg, `Successfully ${toastAction}`, toastText);
          this.confirmModal = false;
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.errorModal("Something went wrong!");
        throw err;
      } finally {
        this.LoaderStatus = false;
      }
      this.closeMainDeleteModal();
      this.$bvModal.hide("closejd");
    },
    closeDeleteJd(val) {
      this.showDeleteModal = val;
    },
    deleteJD(deleteJobData) {
      let payload = {
        jobID: this.delDetails.jobID,
        customerID: this.delDetails.customerID,
        positionStatus: parseInt(deleteJobData.positionStatus),
        comments: deleteJobData.comments,
      };
      this.buttonLoader = true;
      this.$store
        .dispatch("jobDescriptionVUEX/deleteJobDesc", payload)
        .then((res) => {
          if (res.status == 200) {
            this.$emit("resetPagination");
            this.dynamicToast(
              "success",
              "Successfully deleted",
              `"${this.delDetails.title}" has been deleted successfully.`
            );
            this.deselectJob();
            this.showDeleteModal = false;
            this.buttonLoader = false;
          } else {
            this.errorModal("Something went wrong!");
          }
        })
        .catch((err) => {
          this.errorModal("Something went wrong!");
          throw err;
        });
      this.$bvModal.hide("deleteModal");
      this.toggleIconValue = "";
    },
    closeFolder() {
      this.$store.commit("folderVUEX/saveSelectedFolders", []);
      this.$store.commit("folderVUEX/saveSelectedUsers", []);
      this.$store.commit("folderVUEX/setActiveFolder", {});
      this.$store.commit("folderVUEX/setActiveFolderID", "");
      this.$store.commit("folderVUEX/setModalType", "");
      this.showFolderModal = false;
    },
    saveRecruiters() {
      this.editableJD.assignedTo = [];
      this.editableJD.userFolderIDs.Recruiters = [];
      this.selectedUsersList.forEach((user) =>
        this.editableJD.assignedTo.push(JSON.parse(user))
      );
      this.selectedFoldersList.forEach((folder) =>
        this.editableJD.userFolderIDs.Recruiters.push(folder)
      );
      this.$store.commit("folderVUEX/saveSelectedUsers", []);
      this.$store.commit("folderVUEX/saveSelectedFolders", []);

      this.showFolderModal = false;
      this.reassign();
    },
    async reassign() {
      try {
        const response = await updateDraft(this.editableJD);
        if (response.status == 200) {
          this.$emit("resetPagination");
          this.$store.commit(
            "jobDescriptionVUEX/editCurrentJobDesc",
            this.editableJD
          );

          let payload = {
            customerID: this.$route.params.customerID,
            type: this.statusType,
          };
          this.$store.dispatch("jobDescriptionVUEX/getJobDesc", payload);
          if (this.editableJD.assignedTo.length > 0) {
            this.successModal("Recruiters Assigned Successfully!");
          } else {
            this.successModal("Job not assigned to any recruiter");
          }
          this.editableJD = {};
        }
      } catch (error) {
        this.errorModal("Assigning recruiters failed");
        this.$store.dispatch(
          "jobDescriptionVUEX/getJobDesc",
          this.$route.params.customerID
        );
        throw new Error(
          `Failed! assigning recrtuiters ! status: ${error.status}`
        );
      }
    },

    reopenjd(data) {
      data.activateJD = true;
      this.$router.push({
        path: `/jobs/editjob/${data.jobID}`,
        query: {
          customerID: this.customerID,
          cardName: this.$route.params.cardName,
          activateJD: data.activateJD,
          gridView: this.gridView,
        },
      });
    },
    async generatePositionIds() {
      if (this.cloneResponse.openingsCount != null) {
        const payload = {
          noOfPositions: parseInt(this.cloneResponse.openingsCount),
          jobName: this.cloneResponse.title,
          customerName: this.customerName,
        };

        try {
          const result = await generatePositionIds(payload);
          if (result.status === 200) {
            this.cloneResponse.recruiterConfig.positionIDs =
              result.data.data.id;
          }
        } catch (error) {
          console.error("Error generating position IDs:", error);
        }
      }
    },
    async cloneJob(newJdTitle) {
      this.buttonLoader = true;
      try {
        this.LoaderStatus = true;
        let payload = {
          type: 2,
          jobID: this.clonejobId,
        };
        const res = await getJobList(payload);
        if (res.status == 200) {
          this.viewMoreJDIndex = null;
          this.cloneResponse = res.data.data;
          await this.addCloneJob(newJdTitle);
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    closejdtype(data) {
      if (this.closedModal) {
        this.headerMsg = "Close Job";
        this.buttonMsg = "Close";
      } else {
        this.headerMsg = "On-Hold Job";
        this.buttonMsg = "Confirm";
      }
      this.closejob = data;
      this.confirmModal = true;
    },
    goToEditJD(job) {
      this.$router.push({
        name: "CreateJob",
        query: {
          jobID: job.jobID,
          itype: this.jdtypeselected,
          isort: this.sortSelected,
          type:
            job.status === "1" && job.preApproved
              ? "Edit"
              : job.status === "1"
              ? "Create"
              : !job.active
              ? "Activate"
              : job.closed
              ? "Re-Open"
              : "Edit",
          customerName: this.$route.query.cardName,
          gridView: this.gridView,
        },
        params: {
          customerName: this.$route.query.cardName,
        },
      });
    },
    closeCloneModal() {
      this.cloneResponse.title = "";
      this.cloneJobId = null;
      this.cloneTitle = null;
      this.cloneModal = false;
      this.duplicateCloneName = false;
    },
    cloneJD(job) {
      this.cloneResponse.title = "";
      this.clonejobId = job.jobID;
      this.cloneTitle = job.title;
      this.cloneModal = true;
    },
    closeModal(data) {
      this[data] = false;
    },
    async checkForInterviews(type) {
      try {
        this.closejob = this.delDetails;
        let payload = {
          jobID: this.delDetails.jobID,
        };
        let res = await checkInterviews(payload);
        if (res.status === 200) {
          if (type == "on-hold") this.openCloseModal(this.delDetails, true);
          else {
            this.actionType = null;
            this.fromClose = type == "close" ? true : false;
            this.showDeleteModal = true;
          }
        } else if (res.status === 409) {
          this.actionType = type;
          this.showCloseModal = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    openCloseModal(job, hold) {
      this.closedModal = hold ? false : true;
      this.closejdtype(job);
    },
    openModal(job, type) {
      if (type == "on-hold" && job.onHold) {
        this.openCloseModal(job, true);
      } else {
        this.delDetails = job;
        if (this.delDetails.approved) {
          this.checkForInterviews(type);
        } else if (type == "delete") {
          this.fromClose = false;
          this.showDeleteModal = true;
        } else if (type == "on-hold") this.openCloseModal(job, true);
        else this.openCloseModal(job);
      }
    },
  },
};

export default jobDashboardMixins;
